export default "__VITE_ASSET__BUkH$_80__"